import { render, staticRenderFns } from "./NavigationOverlay.vue?vue&type=template&id=5a95c71f&scoped=true&"
import script from "./NavigationOverlay.vue?vue&type=script&lang=js&"
export * from "./NavigationOverlay.vue?vue&type=script&lang=js&"
import style0 from "./NavigationOverlay.vue?vue&type=style&index=0&id=5a95c71f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a95c71f",
  null
  
)

export default component.exports